declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Safely push a payload into window.dataLayer. Initializes the array if it
 * does not exist. Errors are swallowed so a broken GTM stub never throws.
 */
export function pushDataLayer(payload: Record<string, unknown>): void {
  try {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch {
    /* analytics best-effort */
  }
}
